import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-change-password',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {
  public message: string = '';
  public infoMode: boolean = false;
  public heading: string = '';

  constructor(public dialogRef: MdDialogRef<ConfirmDialogComponent>) {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/confirm-dialog/confirm-dialog.component.ts